import { ReactNode } from 'react'
import {
  useFloating,
  useInteractions,
  FloatingPortal,
} from '@floating-ui/react'
import classNames from 'classnames'
import './tooltip.css'

interface TooltipOwnProps {
  children: ReactNode
  className?: string
  disabled?: boolean
  isOpen?: boolean
}

type TooltipProps = TooltipOwnProps &
  Pick<ReturnType<typeof useFloating>, 'floatingStyles' | 'refs'> &
  Pick<ReturnType<typeof useInteractions>, 'getFloatingProps'>

export const Tooltip = ({
  children,
  className,
  disabled,
  floatingStyles,
  getFloatingProps,
  isOpen,
  refs,
}: TooltipProps) => (
  <FloatingPortal>
    {isOpen && !disabled && (
      <div
        className={classNames('tooltip', className)}
        ref={refs.setFloating}
        style={floatingStyles}
        {...getFloatingProps()}
      >
        {children}
      </div>
    )}
  </FloatingPortal>
)
